import { Modal, Typography } from 'antd';
const { Title } = Typography;

/**
 * 
 * @returns 
 */
export const FullModal = ({ open, title = '', onClose, children }) => {
  return (
    <Modal
      wrapClassName="component-container-full-modal"
      title={<Title level={5}>{title || ''}</Title>}
      open={open}
      closable={false}
      footer={[

      ]}
    >
      {children}
    </Modal>
  );
};
